import classNames from 'classnames';
import { MouseEventHandler, ReactNode } from 'react';

type InfoFieldProps = {
  label: string;
  value?: string | number;
  className?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  icon?: ReactNode;
};

const InfoField = (props: InfoFieldProps) => {
  const { label, value, className, onClick, icon } = props;

  return (
    <div className={classNames('flex flex-column mr-4', className)}>
      <div className='flex items-center'>
        <div className='font-medium text-base md:text-lg leading-normal tracking-default text-gray-devil'>{label}</div>
        {icon && <div className='ml-2 cursor-pointer'>{icon}</div>}
      </div>
      <div
        onClick={onClick}
        className='font-medium text-lg md:text-21 leading-30 tracking-normalTight text-mine-shaft pr-6 wrap-break-word'
      >
        {value || 'n/a'}
      </div>
    </div>
  );
};

export default InfoField;
